export const services = [
    {
        id: "stained-leaded-glass",
        number: "01",
        title: "Stained & Leaded Glass",
        category: "Glass Services",
        badge: "Primary Service",
        badgeType: "primary",
        description: "Comprehensive restoration, conservation, and creation of stained glass, leaded glass, and art glass windows. From ecclesiastical masterpieces to Victorian-era transoms, we preserve the artistry that defines historic buildings.",
        features: [
            "Stained glass conservation & structural releading",
            "Period-appropriate glass sourcing & fabrication",
            "Protective glazing & ventilation systems"
        ],
        fullDescription: [
            "Vintage Glass Works specializes in the restoration of stained and leaded glass windows—architectural features that bring light, color, and character to historic buildings. Our work includes ecclesiastical windows in places of worship, decorative art glass in institutional buildings, and intricate leaded glass in period structures.",
            "We approach each project with a commitment to preservation as our top priority. Our team carefully documents existing conditions, assesses structural integrity, and develops restoration plans that honor the original craftsmanship while ensuring long-term stability. Where glass has been lost or damaged beyond repair, we source period-appropriate replacement glass or commission custom fabrication to match the original character.",
            "Our in-house capabilities include complete window removal, sash and frame reconstruction, lead came replacement, glass cleaning and stabilization, protective glazing systems, and reinstallation.",
            "Whether your project involves a single rose window or an entire campus of historic buildings, we bring the expertise, equipment, and project management capabilities that general contractors and institutional clients require."
        ],
        offerings: [
            "Full-service stained-glass restoration",
            "Sash and frame reconstruction (metal & wood)",
            "Lead came replacement and structural releading",
            "Period-appropriate glass sourcing and custom fabrication",
            "Protective glazing and ventilation systems",
            "Detailed condition reporting and archival documentation"
        ],
        images: [
            "/images/services/glass/hero.jpg",
            "/images/services/glass/hero-2.jpg",
            "/images/services/glass/glass-1.jpg",
            "/images/services/glass/glass-2.jpg",
            "/images/services/glass/glass-3.jpg",
            "/images/services/glass/glass-4.jpg",
            "/images/services/glass/glass-5.jpg",
            "/images/services/glass/glass-6.jpg",
            "/images/services/glass/glass-7.jpg"
        ],
        seo: {
            title: "Stained & Leaded Glass Restoration",
            description: "Expert stained glass restoration and leaded glass repair for churches, historic buildings, and institutions throughout Maine and New England. Conservation, releading, and protective glazing services.",
            keywords: ["stained glass restoration, leaded glass repair, church window restoration, art glass conservation, protective glazing, Maine stained glass"]
        }
    },
    {
        id: "wood-metal-sash-restoration",
        number: "02",
        title: "Wood & Metal Sash Restoration",
        category: "Window Services",
        badge: "Specialty",
        badgeType: "specialty",
        description: "Expert restoration of historic wood and metal window systems, including sash repair, glazing, weatherization, and complete window reconstruction. We preserve original windows while improving thermal performance and operability.",
        features: [
            "Wood sash repair, restoration & reconstruction",
            "Historic steel sash restoration",
            "Custom profile milling & jamb extensions"
        ],
        fullDescription: [
            "Historic windows represent irreplaceable craftsmanship—old-growth lumber, hand-forged hardware, and glass with character that cannot be replicated by modern manufacturing. Vintage Glass Works specializes in restoring these original window systems rather than replacing them, preserving both the material heritage and the visual integrity of historic buildings.",
            "Our wood sash restoration services include minor repairs to complete sash reconstruction, and profile replication for missing elements. We remove all finishes and glass. We reuse original glass if it has an identifiable character. If not, the glass is replaced with period correct glass set in a new glazing bed and reglazed. All original period hardware is restored or replaced with solid brass or bronze replicated pieces. We also address paint failure and glazing compound deterioration — returning windows to full operability while maintaining their historic character.",
            "Steel window services include removal and restoration. Small repairs to fabrication. All surfaces, glass, and hardware restored for aesthetics and operation. Where thermal performance is a concern, we work with architects to develop solutions that improve efficiency without compromising historic integrity.",
            "Our approach emphasizes repair over replacement. When elements are missing or deteriorated beyond repair, we fabricate new components to match existing profiles exactly, ensuring seamless integration with original materials."
        ],
        offerings: [
            "Wood sash repair, restoration, and reconstruction",
            "Historic steel sash restoration",
            "Jamb extension fabrication and installation",
            "Period hardware restoration and replication",
            "Weatherstripping and thermal improvement",
            "Historic glass retention and restoration",
            "Custom profile milling for missing elements"
        ],
        images: [
            "/images/services/sash/bowdoin.jpg",
            "/images/services/sash/islesboro.jpg",
            "/images/services/sash/184-sash.jpg",
            "/images/services/sash/bowdoin-progress.jpg",
            "/images/services/sash/wood-sash.jpg"
        ],
        seo: {
            title: "Historic Wood & Metal Window Restoration",
            description: "Professional wood sash and steel window restoration in Maine and New England. Expert repair, reglazing, weatherization, and custom profile milling for historic windows.",
            keywords: ["wood sash restoration, historic window repair, steel window restoration, window reglazing, sash repair Maine, historic window preservation"]
        }
    },
    {
        id: "historic-door-restoration",
        number: "03",
        title: "Historic Door Restoration",
        category: "Door Services",
        badge: "Specialty",
        badgeType: "specialty",
        description: "Complete restoration of historic entry doors, interior doors, and door systems—including wood repair, hardware refurbishment, glass panel restoration, and custom replication of missing elements.",
        features: [
            "Complete historic door restoration & reconstruction",
            "Custom door fabrication to match originals",
            "Period hardware restoration & replication"
        ],
        fullDescription: [
            "Historic doors serve as the threshold between past and present—the first impression of a building's character and craftsmanship. Vintage Glass Works provides comprehensive door restoration services for institutional, ecclesiastical, and commercial historic buildings.",
            "Our scope encompasses exterior entry systems, interior passage doors, vestibule assemblies, and specialty elements such as transoms, sidelights, and decorative glass panels. We address structural issues including joint failure, bottom rail rot, and panel deterioration through careful repair and selective replacement that preserves as much original material as possible.",
            "Hardware restoration is integral to our door work. We clean, repair, and refinish original hinges, locksets, closers, and decorative elements—or source period-appropriate replacements when originals are missing or deteriorated beyond repair. For buildings requiring enhanced security or accessibility, we work with architects to integrate modern systems without compromising historic character.",
            "When doors are missing or deteriorated beyond repair, we fabricate custom replacement doors to match original designs. Working from historic photographs, existing doors elsewhere in the building, or period pattern books, we replicate profiles, panel configurations, and decorative details to ensure authentic results."
        ],
        offerings: [
            "Complete historic door restoration and reconstruction",
            "Custom door fabrication to match historic originals",
            "Transom and sidelight restoration",
            "Period hardware restoration and replication",
            "Leaded and stained-glass panel integration",
            "Vestibule and entry system restoration",
            "Finish restoration and preservation"
        ],
        images: [
            "/images/services/door/hero.jpg",
            "/images/services/door/south-parish.jpg",
            "/images/services/door/121-door.jpg",
            "/images/services/door/usm.jpg",
            "/images/services/door/mahogany-door.jpg",
            "/images/services/door/belfast.jpg"
        ],
        seo: {
            title: "Historic Door Restoration & Custom Fabrication",
            description: "Expert historic door restoration services in Maine and New England. Entry door repair, custom fabrication, hardware restoration, and transom restoration for historic buildings.",
            keywords: ["historic door restoration, antique door repair, custom door fabrication, period hardware restoration, entry door restoration Maine"]
        }
    },
    {
        id: "laser-restoration",
        number: "04",
        title: "Laser Restoration",
        category: "New Technology",
        badge: "New Service",
        badgeType: "new",
        description: "Precision laser cleaning technology for delicate historic surfaces—removing decades of grime, paint, and corrosion without damaging original materials.",
        features: [
            "Non-abrasive surface cleaning",
            "Paint and coating removal",
            "Precision detail work"
        ],
        fullDescription: [
            "Vintage Glass Works now offers state-of-the-art laser restoration technology, providing unparalleled precision for cleaning and restoring delicate historic surfaces.",
            "Traditional cleaning methods—chemical strippers, sandblasting, and manual scraping—risk damaging the very materials we're trying to preserve. Laser cleaning changes everything. By precisely targeting unwanted layers while leaving original surfaces untouched, we can restore intricate details that were previously considered too fragile to clean.",
            "Our laser systems are effective on a wide range of materials including stone, brick, metal, and wood. Whether removing centuries of soot from carved stonework, stripping failed coatings from ornamental metalwork, or cleaning delicate gilded surfaces, laser technology delivers results that traditional methods simply cannot match."
        ],
        offerings: [
            "Laser cleaning of historic masonry and stonework",
            "Paint and coating removal from ornamental metals",
            "Soot and pollution removal from architectural details",
            "Delicate surface cleaning for gilded elements",
            "Graffiti removal from sensitive surfaces",
            "Pre-restoration surface preparation"
        ],
        process: [
            "Surface analysis and material identification",
            "Laser parameter calibration for specific materials",
            "Test cleaning on inconspicuous area",
            "Systematic cleaning with real-time monitoring",
            "Final inspection and documentation"
        ],
        images: [
            "/images/services/laser/laser-restoration.jpg",
            "/images/services/laser/laser-restoration-2.jpg",
            "/images/services/laser/laser-restoration-3.jpg"
        ],
        seo: {
            title: "Laser Restoration & Cleaning Services",
            description: "Advanced laser cleaning technology for historic surfaces in Maine and New England. Non-abrasive paint removal, stone cleaning, and precision restoration without damaging original materials.",
            keywords: ["laser restoration, laser cleaning historic buildings, non-abrasive paint removal, stone cleaning laser, historic surface restoration"]
        }
    },
    {
        id: "large-scale-preservation",
        number: "05",
        title: "Large-Scale Preservation",
        category: "Institutional",
        badge: "Institutional",
        badgeType: "institutional",
        description: "Comprehensive preservation services for universities, churches, and historic buildings. We manage multi-phase restoration projects from initial assessment through final documentation, serving as a single-source partner for general contractors and institutional clients.",
        features: [
            "Multi-phase project planning & execution",
            "General contractor coordination & integration",
            "On-site workshop capability for large projects"
        ],
        fullDescription: [
            "Large-scale historic preservation projects require more than skilled craftsmanship—they demand project management capabilities, coordination expertise, and the capacity to execute substantial scopes of work on schedule and within budget. Vintage Glass Works serves as a trusted subcontractor and partner for general contractors, construction managers, and institutional facilities teams working on significant preservation projects.",
            "Our institutional experience spans university campus buildings, religious institutions, municipal landmarks, and commercial historic structures. We understand the complexities of working within occupied buildings, coordinating with multiple trades, and meeting the documentation requirements of preservation tax credit projects and grant-funded work.",
            "Recent institutional projects include the Thompson Block, William Widgery Thomas Block, and Boyd Block restorations in Portland's historic Old Port district—comprehensive scopes encompassing exterior restoration, window replacement, millwork restoration, and custom fabrication totaling hundreds of linear feet of architectural elements."
        ],
        offerings: [
            "Multi-phase project planning and execution",
            "On-site workshop establishment for large projects",
            "General contractor coordination and integration",
            "Historic preservation tax credit documentation",
            "Archival condition reporting and photography",
            "Phased work scheduling for occupied buildings",
            "Single-source responsibility for window, door, and millwork scopes"
        ],
        images: [
            "/images/services/preservation/hero-2.jpg",
            "/images/services/preservation/121-exterior.jpg",
            "/images/services/preservation/184-exterior.jpg",
            "/images/services/preservation/178-tripple.jpg",
            "/images/services/preservation/bowdoin.jpg",
            "/images/services/preservation/bowdoin-outside.jpg"
        ],
        seo: {
            title: "Large-Scale Historic Preservation Services",
            description: "Comprehensive institutional preservation services for universities, churches, and historic buildings in New England. Multi-phase project management, tax credit documentation, and general contractor coordination.",
            keywords: ["institutional preservation, university building restoration, church restoration, historic tax credit projects, large scale preservation Maine"]
        }
    },
    {
        id: "historic-millwork-replication",
        number: "06",
        title: "Historic Millwork & Trim Replication",
        category: "Fabrication",
        badge: "Fabrication",
        badgeType: "fabrication",
        description: "Custom fabrication and replication of historic mouldings, trim, architectural elements, and ornamental woodwork. When original elements are missing or deteriorated beyond repair, we create period-correct replacements that integrate seamlessly with existing details.",
        features: [
            "Custom moulding & trim profile milling",
            "Architectural element replication",
            "Period-correct material sourcing"
        ],
        fullDescription: [
            "Historic buildings often require replacement of deteriorated or missing millwork elements. Whether a single damaged bracket or hundreds of linear feet of cornice, Vintage Glass Works provides custom fabrication services that replicate original profiles with precision.",
            "Our millwork capabilities include everything from simple window casings to elaborate decorative elements—corbels, pendants, dentil courses, and ornamental scrollwork. We work from existing samples, historic photographs, or architectural drawings to develop accurate profiles that match the originals in every detail.",
            "Our shop is equipped to mill custom profiles, whether matching a single existing casing or producing hundreds of linear feet of cornice for a large institutional project.",
            "Quality control is essential to successful replication. Each fabricated element is checked against original samples or approved drawings before finishing. We coordinate with painting contractors or provide primed elements ready for finish, depending on project requirements. The goal is always seamless integration—new work that is indistinguishable from preserved originals."
        ],
        offerings: [
            "Custom moulding and trim profile milling",
            "Cornice, frieze, and dentil fabrication",
            "Decorative element replication (corbels, brackets, scrolls, pendants)",
            "Spandrel and panel system fabrication",
            "Exterior architectural trim production",
            "Interior casing, base, and crown replication",
            "Shop drawing development and documentation",
            "Period-appropriate material sourcing"
        ],
        images: [
            "/images/services/millwork/121-fixture-building.jpg",
            "/images/services/millwork/121-fixtures.jpg",
            "/images/services/millwork/curved-arches.jpg",
            "/images/services/millwork/178-stair.jpg",
            "/images/services/millwork/frame.jpg",
            "/images/services/millwork/fixture.jpg"
        ],
        seo: {
            title: "Historic Millwork & Trim Replication",
            description: "Custom millwork fabrication and historic trim replication in Maine and New England. Period-correct mouldings, cornices, corbels, and architectural elements for historic buildings.",
            keywords: ["historic millwork, custom moulding fabrication, trim replication, architectural millwork Maine, period millwork restoration"]
        }
    },
    {
        id: "furniture-laser-stripping",
        number: "07",
        title: "Furniture Laser Stripping & Refinishing",
        category: "Local Services",
        badge: "Local Service",
        badgeType: "local",
        description: "Precision laser technology strips decades of paint, stain, and finish from furniture—no harsh chemicals, no raised grain, no lengthy wait. From kitchen cabinets and cast iron radiators to antique chairs and ornamental metal legs, stripping is fast. Refinishing is available at our Gardiner shop.",
        features: [
            "Chemical-free laser stripping — remarkably fast",
            "Works on wood, metal, cast iron & more",
            "Refinishing available in-shop"
        ],
        fullDescription: [
            "Vintage Glass Works has applied our laser restoration expertise to a new local service: precision furniture and fixture stripping. The same technology that removes decades of paint from fragile historic stonework and ornamental metalwork is now available for your furniture, cabinets, and architectural fixtures—without any of the mess, wait, or damage that comes with traditional chemical stripping.",
            "Conventional stripping methods rely on caustic chemical baths, harsh solvents, or aggressive sanding that raises the grain, works its way into carvings, and requires days of drying and neutralizing before you can move to the next step. Our laser targets the finish layer precisely—paint, stain, varnish, lacquer—without touching the substrate beneath. The wood comes out clean and dry. Cast iron comes out bare and ready. Metal legs and hardware come out stripped to bare metal without pitting or distortion.",
            "The speed is something that has to be seen to be believed. Even complex pieces with intricate profiles, carved details, or years of layered paint can be fully stripped in a single day at our Gardiner shop. There is no soaking, no scraping, no waiting for chemicals to do their work. Drop off your piece, and it is ready for the next step far sooner than any traditional method would allow.",
            "Once stripped, we offer full refinishing services—stain, oil, varnish, painted topcoats, or custom finishes. Refinishing is a craft that deserves its own time, and we do it right. Whether you are restoring a set of kitchen cabinets, refinishing an antique dresser, bringing a cast iron radiator back to life, or refreshing a set of metal-legged chairs, our team will walk you through the options and deliver a result that lasts. Bring your piece to our Gardiner shop and we will take it from there."
        ],
        offerings: [
            "Laser stripping of paint, stain, varnish, and lacquer",
            "Wood furniture — chairs, tables, dressers, cabinets, and more",
            "Kitchen cabinet stripping and refinishing",
            "Cast iron radiator and fixture stripping",
            "Ornamental metal legs, frames, and hardware",
            "Antique and heirloom piece restoration",
            "Full refinishing with stain, oil, varnish, or painted topcoats",
            "In-shop service in Gardiner, Maine"
        ],
        images: [
            "/images/services/furniture/furniture-hero.jpg",
            "/images/services/furniture/furniture-1.jpg",
            "/images/services/furniture/furniture-2.jpg",
            "/images/services/furniture/furniture-3.jpg"
        ],
        seo: {
            title: "Furniture Laser Stripping & Refinishing | Gardiner, Maine",
            description: "Chemical-free furniture stripping using precision laser technology at our Gardiner, Maine shop. Kitchen cabinets, cast iron radiators, metal legs, antiques—stripped fast with no harsh chemicals. At our Gardiner, Maine shop — open to anyone willing to make the trip.",
            keywords: ["furniture stripping Maine, laser furniture stripping, chemical-free paint removal furniture, kitchen cabinet stripping Maine, cast iron radiator stripping, furniture refinishing Gardiner Maine"]
        }
    },
    {
        id: "stained-glass-maintenance",
        number: "08",
        title: "Stained & Leaded Glass Maintenance",
        category: "Glass Maintenance",
        badge: "Maintenance",
        badgeType: "maintenance",
        description: "Professional cleaning and preventative maintenance programs for stained and leaded glass windows using purified-water cleaning methods to enhance clarity, preserve material integrity, and minimize residues.",
        features: [
            "Purified water cleaning for streak-free clarity",
            "Gentle, non-invasive maintenance for historic glass",
            "Condition assessment and preventative care"
        ],
        fullDescription: [
            "Vintage Glass Works offers specialized maintenance services for stained and leaded glass windows to support their long-term preservation and performance. Proper care helps protect historic glass assemblies from environmental buildup, contaminants, and premature deterioration, reducing the frequency and cost of full restoration.",
            "Our maintenance process employs purified water techniques to safely lift dirt, particulates, and airborne deposits without introducing harsh chemicals or abrasive action. By filtering source water to near-zero dissolved solids, this approach ensures a streak-free, residue-free finish while protecting lead came, painted surfaces, putty, and surrounding historic materials.",
            "Each visit includes a visual condition assessment, giving our experts the opportunity to identify early signs of stress, bowing, cracked glass, or failing support systems. When concerns are identified, we provide clear recommendations that align with preservation best practices, enabling proactive care rather than reactive restoration.",
            "This service is ideal for places of worship, institutional buildings, historic residences, and commercial properties that include stained or leaded glass as a character-defining feature. Whether maintaining a single window or an entire set of architecturally significant glazing, our team brings professional planning, safe access equipment, and a preservation-first mindset to every assignment."
        ],
        offerings: [
            "Purified water stained and leaded glass window cleaning",
            "Preventative maintenance programs",
            "Visual condition assessments and reporting",
            "Safe cleaning for historic and elevated windows",
            "Coordination with long-term preservation planning",
            "Expert recommendations for extending window longevity"
        ],
        images: [
            "/images/services/maintenance/hero.jpg",
            "/images/services/maintenance/maintenance-1.jpg",
            "/images/services/maintenance/maintenance-2.jpg",
            "/images/services/maintenance/maintenance-3.jpg",
            "/images/services/maintenance/maintenance-4.jpg"
        ],
        seo: {
            title: "Stained Glass Cleaning & Maintenance",
            description: "Professional stained and leaded glass maintenance services in Maine and New England. Purified water cleaning, condition assessments, and preventative care programs for historic windows.",
            keywords: ["stained glass cleaning, leaded glass maintenance, church window cleaning, historic glass care, preventative glass maintenance"]
        }
    },
    {
        id: "restoration-consulting",
        number: "08",
        title: "Restoration Consulting",
        category: "Advisory Service",
        badge: "Advisory",
        badgeType: "advisory",
        description: "Expert consulting services for building owners, architects, and contractors navigating historic restoration projects. We provide condition assessments, preservation planning, specification development, and guidance on period-correct restoration approaches.",
        features: [
            "Condition assessments & preservation planning",
            "Specification development & review",
            "Period-correct restoration guidance"
        ],
        fullDescription: [
            "Not every historic building project begins with a clear path forward. Building owners may be unsure whether windows can be restored or must be replaced. Architects may need specialized input on appropriate preservation approaches. General contractors may require guidance on executing unfamiliar historic scopes. Vintage Glass Works provides consulting services that help clients make informed decisions about their historic restoration projects.",
            "Our consulting services begin with thorough condition assessments. We evaluate existing windows, doors, and architectural elements to determine what can be preserved, what requires restoration, and what may need replacement. Our reports include detailed photography, condition ratings, and recommendations prioritized by urgency and impact.",
            "For architects and specifiers, we provide technical guidance on period-correct materials, appropriate restoration methods, and realistic project parameters. We can assist with specification development, ensuring that bid documents accurately describe the work required and the quality standards expected.",
            "For building owners exploring preservation options, we offer guidance on the restoration process, realistic budgeting, and the long-term value of preservation versus replacement. We help clients understand what questions to ask, what to look for in qualified contractors, and how to evaluate proposals.",
            "Our consulting services can stand alone or serve as the first phase of a larger restoration project. Either way, our goal is to ensure that every client has the information they need to make confident decisions."
        ],
        offerings: [
            "Comprehensive condition assessments and reporting",
            "Preservation planning and prioritization",
            "Specification development and review",
            "Period-correct material and method guidance",
            "Budget development and project scoping",
            "Owner representation and contractor evaluation",
            "Historic preservation standards consultation"
        ],
        images: [
            "/images/services/consulting/consulting-hero.jpg",
            "/images/services/consulting/consulting-plan.jpg",
            "/images/services/consulting/consulting-church.jpg",
            "/images/services/consulting/consulting-outside.jpg"
        ],
        seo: {
            title: "Historic Restoration Consulting Services",
            description: "Expert restoration consulting for building owners, architects, and contractors in Maine and New England. Condition assessments, preservation planning, and specification development.",
            keywords: ["restoration consulting, historic preservation consulting, condition assessment, preservation planning, historic building consultant Maine"]
        }
    }
];

// Helper function to find service by slug/id
export const getServiceBySlug = (slug) => {
    return services.find(service => service.id === slug);
};
